"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var databus_1 = require("@ravilm/databus");
var constants_1 = require("../constants");
exports.isUserAuthentificatedSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.AUTHENTIFICATE_USER_STATE })
        ? databus_1.Databus.getData({ name: constants_1.AUTHENTIFICATE_USER_STATE })
        : false;
};
exports.userDataSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.USER_DATA })
        ? databus_1.Databus.getData({ name: constants_1.USER_DATA })
        : {};
};
exports.userDataIsLoadingSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.USER_DATA_LOADING })
        ? databus_1.Databus.getData({ name: constants_1.USER_DATA_LOADING })
        : false;
};
exports.userPermissionsSelector = function (scope) {
    return databus_1.Databus.getData({ name: constants_1.USER_PERMISSIONS })
        ? databus_1.Databus.getData({ name: constants_1.USER_PERMISSIONS })[scope]
        : false;
};
exports.userDataPermissionsSelector = function (scope) {
    return databus_1.Databus.getData({ name: constants_1.USER_DATA_PERMISSIONS })
        ? databus_1.Databus.getData({ name: constants_1.USER_DATA_PERMISSIONS })[scope]
        : {};
};
